import React from 'react';
import { FadeIn } from './FadeIn';
import { Package, Trophy, BookOpen, Dumbbell, PersonStanding, Pill, Scale, BarChart3, Brain, Wrench, CheckCircle, Zap, Gift, Target, ClipboardList, Ruler, UtensilsCrossed, CalendarDays, Lightbulb } from 'lucide-react';
export function WhatYouGet() {
  const tomos = [{
    emoji: '🥩',
    title: 'Planes según objetivo',
    desc: 'Hipertrofia · Definición · Recomposición corporal'
  }, {
    emoji: '🏃',
    title: 'Nutrición según deporte',
    desc: 'Fuerza · Resistencia · Deportes de equipo'
  }, {
    emoji: '💊',
    title: 'Suplementación con criterio',
    desc: 'Dosis · timing · qué usar y qué NO'
  }, {
    emoji: '⚖️',
    title: 'Estrategias avanzadas',
    desc: 'Peak week · competencia · puesta a punto'
  }, {
    emoji: '📊',
    title: 'Evaluación y seguimiento',
    desc: 'Anamnesis · evolución · ajustes'
  }, {
    emoji: '🧠',
    title: 'Casos reales resueltos',
    desc: 'Qué hacer en consulta paso a paso'
  }];
  const herramientas = ['Plantillas de planes deportivos editables', 'Protocolos de suplementación por objetivo', 'Fichas de evaluación completas', 'Checklists de consulta', 'Registros de progreso del paciente', 'Guiones para explicar estrategias'];
  const resultados = ['Armás planes en minutos', 'Tenés criterio para decidir', 'Dejás de improvisar'];
  const bonos = [{
    emoji: '🎯',
    title: 'Plantillas de planes listas'
  }, {
    emoji: '💊',
    title: 'Guía rápida de suplementación'
  }, {
    emoji: '📋',
    title: 'Formularios de consulta'
  }, {
    emoji: '📏',
    title: 'Checklist de evaluación corporal'
  }, {
    emoji: '🍽',
    title: 'Recetario fitness alto en proteína'
  }, {
    emoji: '📆',
    title: 'Sistema de organización profesional'
  }];
  return <section className="py-10 px-3" data-id="element-248">
      <div className="max-w-4xl mx-auto" data-id="element-249">
        {/* Main heading */}
        <FadeIn className="text-center mb-8" data-id="element-250">
          <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/20 rounded-full px-4 py-1.5 mb-4" data-id="element-251">
            <span className="text-lg" data-id="element-252">📦</span>
            <span className="text-accent font-bold text-sm uppercase tracking-wider" data-id="element-253">
              ¿Qué recibís hoy?
            </span>
          </div>
        </FadeIn>

        {/* Sistema 360 */}
        <FadeIn className="text-center mb-8" data-id="element-254">
          <h2 className="font-display text-2xl md:text-4xl font-bold text-white mb-2" data-id="element-255">
            🏆 MEGAPACK NUTRICIÓN DEPORTIVA
          </h2>
          <p className="text-sm md:text-base text-white/60 max-w-2xl mx-auto" data-id="element-256">
            Todo organizado para que entres a consulta y sepas exactamente qué
            hacer.
          </p>
        </FadeIn>

        {/* 6 Tomos */}
        <FadeIn className="mb-8" data-id="element-257">
          <div className="bg-surface border border-accent/20 rounded-2xl p-5 md:p-8" data-id="element-258">
            <h3 className="text-center text-xl md:text-2xl font-bold text-white mb-6 flex items-center justify-center gap-2" data-id="element-259">
              <span className="text-2xl" data-id="element-260">📚</span> 6 TOMOS LISTOS PARA USAR
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-261">
              {tomos.map((tomo, idx) => <div key={idx} className="bg-white/[0.03] border border-white/10 rounded-xl p-4 hover:border-accent/30 transition-colors" data-id="element-262">
                  <span className="text-2xl mb-2 block" data-id="element-263">{tomo.emoji}</span>
                  <h4 className="text-sm font-bold text-white mb-1" data-id="element-264">
                    {tomo.title}
                  </h4>
                  <p className="text-xs text-white/50 leading-relaxed" data-id="element-265">
                    {tomo.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Herramientas */}
        <FadeIn className="mb-8" data-id="element-266">
          <div className="bg-accent/[0.04] border border-accent/25 rounded-2xl p-5 md:p-8" data-id="element-267">
            <h3 className="text-center text-xl md:text-2xl font-bold text-white mb-2 flex items-center justify-center gap-2" data-id="element-268">
              <span className="text-2xl" data-id="element-269">🧰</span> HERRAMIENTAS LISTAS
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mt-5" data-id="element-270">
              {herramientas.map((item, idx) => <div key={idx} className="flex items-start gap-2.5" data-id="element-271">
                  <CheckCircle size={16} className="text-green-500 shrink-0 mt-0.5" data-id="element-272" />
                  <span className="text-white/80 text-sm" data-id="element-273">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Resultado directo */}
        <FadeIn className="mb-8" data-id="element-274">
          <div className="bg-surface border border-accent/30 rounded-2xl p-5 md:p-6 text-center" data-id="element-275">
            <h3 className="text-lg md:text-xl font-bold text-accent mb-4 flex items-center justify-center gap-2" data-id="element-276">
              <span className="text-xl" data-id="element-277">⚡</span> RESULTADO DIRECTO
            </h3>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6" data-id="element-278">
              {resultados.map((item, idx) => <div key={idx} className="flex items-center gap-2 text-white/90 font-medium text-sm" data-id="element-279">
                  <span className="text-accent" data-id="element-280">👉</span>
                  {item}
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Bonos */}
        <FadeIn className="mb-6" data-id="element-281">
          <div className="bg-black border border-accent/20 rounded-2xl p-5 md:p-8" data-id="element-282">
            <h3 className="text-center text-xl md:text-2xl font-bold text-white mb-5 flex items-center justify-center gap-2" data-id="element-283">
              <span className="text-2xl" data-id="element-284">🎁</span> + BONOS INCLUIDOS{' '}
              <span className="bg-accent text-black text-xs font-black px-2.5 py-0.5 rounded-full uppercase tracking-wide" data-id="element-285">
                Gratis
              </span>
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5" data-id="element-286">
              {bonos.map((bono, idx) => <div key={idx} className="flex items-center gap-2.5 bg-accent/[0.04] border border-accent/15 rounded-lg px-3.5 py-2.5" data-id="element-287">
                  <span className="text-lg" data-id="element-288">{bono.emoji}</span>
                  <span className="text-white/80 text-sm font-medium" data-id="element-289">
                    {bono.title}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Resumen */}
        <FadeIn data-id="element-290">
          <div className="text-center bg-accent/10 border border-accent/25 rounded-xl p-5" data-id="element-291">
            <p className="flex items-center justify-center gap-2 text-white font-bold text-base md:text-lg" data-id="element-292">
              <span className="text-xl" data-id="element-293">💡</span> EN RESUMEN
            </p>
            <p className="text-white/70 text-sm md:text-base mt-2" data-id="element-294">
              No comprás PDFs. Comprás un{' '}
              <span className="text-accent font-semibold" data-id="element-295">sistema</span> que te
              dice qué hacer en consulta.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}